export default {
  methods: {
    checkPromotionValid(promotions)
    {
      let validPromotion = null;
      promotions.forEach(promotion => {
        if (promotion.attributes.publishedAt) {
          const fromDate = new Date(promotion.attributes.PromotionPeriodFrom);
          const toDate = new Date(promotion.attributes.PromotionPeriodTo);
          const todayDate = new Date();
          if (todayDate > fromDate && todayDate < toDate) {
            validPromotion = promotion;
          }
        }
      });

      return validPromotion;
    },
    checkPromotionLastCall(promotion) {
      if(promotion?.attributes?.show_last_call) {
        const lastCallDay = 7;
        const todayDate = new Date();
        const toDate = new Date(promotion?.attributes?.PromotionPeriodTo);
        const difference_in_time = toDate - todayDate;
        const difference_in_day = difference_in_time /  (1000 * 3600 * 24);
        if (difference_in_day < lastCallDay) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    calculateDiscountedPremium(originalPrices, discounts) {
      // console.log(discounts);
      let promotionPrices = Array;
      promotionPrices = [];
      let tenYearPremium = 0;
      let twentyYearPremium = 0;
      for (let i = 0; i < 20; i++) {
        const discount = discounts['Year' + parseInt(i + 1)];
        if(discount === 0)
        {
          promotionPrices[i] = null;
          if (i < 10) {
            tenYearPremium += parseFloat(originalPrices[i]);
          }
          twentyYearPremium += parseFloat(originalPrices[i]);
        }
        else
        {
          const calulatedPrice = ((originalPrices[i] * (100 - discount)) / 100);
          promotionPrices[i] = parseInt(calulatedPrice.toFixed(0));
          if (i < 10) {
            tenYearPremium += calulatedPrice;
          }
          twentyYearPremium += calulatedPrice;
        }
      }

      // console.log(tenYearPremium);
      // console.log(twentyYearPremium);

      const discountedTenYearAvgPremium = parseInt((tenYearPremium / 10).toFixed(0));
      const discountedTwentyYearAvgPremium = parseInt((twentyYearPremium / 20).toFixed(0));
      const returnObj = {
        promotionPrices,
        discountedTenYearAvgPremium,
        discountedTwentyYearAvgPremium
      };
      // console.log(returnObj);
      return returnObj;
    },

    calculateTermlifeScore(tenYearConstant,twentyYearConstant, tenYearAvgPrem, twentyYearAvgPrem, sumAssured, coverageScore){
      // calculate 10year rating and 20year rating
      if (tenYearConstant !== 0 && twentyYearConstant !== 0) {
        const tenYearRating = 0.8 * Math.min((sumAssured / tenYearAvgPrem / tenYearConstant) * 10, 10) + 0.2 * coverageScore;
        const twentyYearRating = 0.8 * Math.min((sumAssured / twentyYearAvgPrem / twentyYearConstant) * 10, 10) + 0.2 * coverageScore;
        return {
          tenYearRating,
          twentyYearRating
        }
      }
      return false;
    }
  }
}